import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowLeft } from "lucide-react";

export default function Gracias() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      data-testid="gracias-page" className="bg-[#0B1F3A] min-h-screen flex items-center">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-40 w-full">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15, duration: 0.8 }}
          className="max-w-2xl">
          <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-10">
            <Check className="text-white" size={28} />
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-white/50 mb-6">Solicitud recibida</div>
          <h1 className="text-5xl md:text-7xl font-serif text-white tracking-tight leading-[1.0]">Gracias por contactar.</h1>
          <p className="mt-8 text-lg md:text-xl text-white/60 leading-relaxed max-w-xl">
            Hemos recibido tu solicitud. Un miembro del equipo de Medite Group revisará tu caso y te responderá en un plazo de un día laborable para concertar tu diagnóstico inicial.
          </p>
          <Link to="/" data-testid="gracias-home-link"
            className="mt-12 inline-flex items-center gap-2 rounded-full bg-white text-[#0B1F3A] px-8 py-4 font-medium hover:scale-[1.03] transition-transform">
            <ArrowLeft size={18} /> Volver al inicio
          </Link>
        </motion.div>
      </div>
    </motion.div>
  );
}
